/**
 * Handing bytes to the browser as a file.
 *
 * **A blob URL rather than a `data:` one.** A data URL of a register export is a very long string
 * in the address bar and in history; the object URL is revoked immediately after the click, so
 * nothing holds the bytes alive once the download has started.
 *
 * **One implementation, because there are three callers and they were about to be three copies**:
 * the register's CSV of a table view, an export artifact, and a generated box of pass codes. The
 * last two are sealed under a one-time password and are fetched through the API client with it in a
 * header — a link cannot set one — so they arrive as a `Blob` and end up here.
 */
export function saveBlob(blob: Blob, filename: string): void {
  const url = URL.createObjectURL(blob);
  const anchor = document.createElement('a');
  anchor.href = url;
  anchor.download = filename;
  anchor.click();
  URL.revokeObjectURL(url);
}

/** The same, for text this application generated rather than bytes the server sent. */
export function saveText(text: string, filename: string, mediaType: string): void {
  saveBlob(new Blob([text], { type: `${mediaType};charset=utf-8` }), filename);
}
